import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

export default class Interno extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        const url = `/api/suporte/interno/`
        axios(url)
            .then(resp => {
                this.setState({ list: resp.data })
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }

    render() {
        return (
            <div className="container mx-auto">
                <div className="form-group row pt-3 text-center">
                    <table className="table mt-4">
                        <thead>
                            <tr>
                                <th>NÚMERO</th>
                                <th>DATA</th>
                                <th>TIPO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRows()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderRows() {
        let select = []
        if (this.state.list) {
            this.state.list.map(suporte => {
                if(!suporte.arquivado && !suporte.resposta) {
                    select.push(
                        <tr key={suporte.numero}>
                            <td>{suporte.numero}</td>
                            <td>{suporte.data}</td>
                            <td>{suporte.tipo}</td>
                            <td>
                                <Link to={`/resposta/${suporte._id}`} target="_blank">
                                    <button className="btn btn-warning">Abrir</button>
                                </Link>
                            </td>
                        </tr>
                    )
                }
            })
        }
        return select
    }
}